import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useSuperAdminSingleOrg } from "../../../../context/SuperAdmin/SingleOrgContext";
import { useAuthContext } from "../../../../hooks/Auth";
import { StyledTableCell } from "../../../../ui-components/StyledTables";
import { useMemo } from "react";
import RowSuborg from "./RowSuborg";

const SingleOrgSuborgsTable = () => {
  const { suborgs, suborgSearchQuery } = useSuperAdminSingleOrg();
  const { canAccess } = useAuthContext();

  // Filtro de suborganizaciones por búsqueda
  const filteredSuborgs = useMemo(() => {
    const normalizedSearch = suborgSearchQuery.toLowerCase().trim();
    return suborgs.filter((s) =>
      s.suborganizacion.toLowerCase().includes(normalizedSearch)
    );
  }, [suborgs, suborgSearchQuery]);

  return (
    <TableContainer
      sx={{
        width: "100%",
        margin: "auto",
        borderRadius: 2,
        overflow: "hidden",
        mt: 2,
      }}
    >
      <Table sx={{ minWidth: 500, width: "100%" }}>
        {/* Cabecera de la tabla */}
        <TableHead sx={{ height: 20, width: "100%" }}>
          <TableRow>
            <StyledTableCell align="center">N°</StyledTableCell>
            <StyledTableCell align="center">Nombre</StyledTableCell>
            <StyledTableCell align="center">Estado</StyledTableCell>
            <StyledTableCell align="center">Acciones</StyledTableCell>
          </TableRow>
        </TableHead>

        {/* Cuerpo de la tabla */}
        <TableBody>
          {filteredSuborgs.length ? (
            filteredSuborgs.map((suborg, index) => (
              <RowSuborg
                key={suborg.id_suborganizacion}
                suborg={suborg}
                index={index}
              />
            ))
          ) : (
            <TableRow>
              <StyledTableCell
                colSpan={9}
                sx={{
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  textAlign: "center",
                }}
              >
                No hay campos aún
              </StyledTableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SingleOrgSuborgsTable;
